module.exports = __webpack_public_path__ + "static/Customize-Colours-1a1-e1403554331982-12dfdeee834e28789a0221aaed8c9d1c.jpg";